<nx-file-upload-delete
  [deleteLabel]="data.field.options?.uploadedLabel ?? data.templateContext.deleteLabel | translate"
  [isUploading]="data.file.isUploading"
  (click)="onRemoveFile($event, data.file)"
></nx-file-upload-delete>
